exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resolution-card[data-v-d821516a]{background:#174ea6;min-height:275px}.resolution-placeholder[data-v-d821516a]{align-items:center;background:#174ea6;display:flex;height:170px;justify-content:center}.resolution-description[data-v-d821516a]{color:#4fa3ff;min-height:50px;word-break:break-word}", ""]);

// exports
